import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-accent/15 bg-surface/40 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxkvik8ui7s">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop742ryb3le">I {totalBonuses} <span className="text-highlight" data-id="element-21" data-mp="15pw2z0yk0oxw">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-accent/20 bg-background/55 shadow-lg shadow-black/30 backdrop-blur-md" data-id="element-22" data-mp="1jgr5lvigm9t1">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-accent/10 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="qzoh0b9c8nsg" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-accent/40 bg-surface/60 text-accent" data-id="element-24" data-mp="2jiegjtxv5evs">
                  <Icon className="h-5 w-5 drop-shadow-glow" aria-hidden="true" data-id="element-25" data-mp="1qth1dzoy7y79" />
                </span>
                <div data-id="element-26" data-mp="1vs24q7zhyxzx">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-highlight" data-id="element-27" data-mp="1vtd4zxtqhnma">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-foreground" data-id="element-28" data-mp="20ptscpt3zxyb">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="25oeskp8d2hmr">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-highlight bg-background/70 px-6 py-6 text-center shadow-lg shadow-black/40 backdrop-blur-md sm:flex-row sm:text-left" data-id="element-30" data-mp="3h4liew2s8t4g">
          <div data-id="element-31" data-mp="1c42hja15oc5p">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-32" data-mp="1c6okewd3q3hl">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-highlight decoration-2" data-id="element-33" data-mp="1m1yodpn28ky0">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="tdt04swssdtf">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-35" data-mp="tf452w1zbrm4">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-highlight" data-id="element-36" data-mp="1760u6cwp5qof">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="12d7tq189h4i5" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}